import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Mapa } from "./components/mapa";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import slider from "./components/slider";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="string">
        <div>
          <Navigation />
          <Header data={landingPageData.Header} />
          <Services data={landingPageData.Services} />
          {/*<Features data={landingPageData.Features} />*/}
          <About data={landingPageData.About} />
          <Mapa />
          {/*<Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />*/}
          <Team data={landingPageData.Team} />
          <Contact data={landingPageData.Contact} />
        </div>
      </Container>
    </React.Fragment>
  );
};

export default App;
